/* eslint-disable no-underscore-dangle */

import helpers from '../../js/helpers';

class FlipCard {
	// ---------------------------------
	// ---------- CONSTRUCTOR ----------
	// ---------------------------------

	constructor(root) {
		this._root = root;
		this._elements = this._findElements();
		this._currentCardId = 0;
		this._array = FlipCard._createShuffledArray(1, 42);

		this._bindEventListeners();
	}

	// -----------------------------
	// ---------- METHODS ----------
	// -----------------------------

	// создаёт и возвращает перемешанный массив чисел в заданном диапазоне
	static _createShuffledArray(min, max) {
		let array = [];

		for (let i = min; i <= max; i++) {
			array.push(i);
		}

		return FlipCard.shuffle(array);
	}

	// перемешать массив чисел в случайном порядке
	static shuffle(original) {
		let array = original;

		for (let i = array.length - 1; i > 0; i--) {
			let j = Math.floor(Math.random() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]];
		}

		return array;
	}

	// находит и возвращает элементы блока
	_findElements() {
		const r = this._root;

		return {
			front: r.querySelector('.flip-card__front'),
			back: r.querySelector('.flip-card__back'),
			loader: r.querySelector('.flip-card__loader'),
			buttonOpen: r.querySelector('.button[name="open"]'),
			buttonRandomWrapper: r.querySelector('.flip-card__button-random'),
			buttonRandom: r.querySelector('.button[name="random"]'),
			arrowLeft: r.querySelector('.flip-card__arrow--left'),
			arrowRight: r.querySelector('.flip-card__arrow--right'),
		};
	}

	// регистрирует обработчики событий
	_bindEventListeners() {
		const {
			buttonOpen,
			buttonRandom,
			arrowLeft,
			arrowRight,
		} = this._elements;

		buttonOpen.addEventListener('click', this._handleButtonOpenClick.bind(this));
		buttonRandom.addEventListener('click', this._handleButtonRandomClick.bind(this));
		arrowLeft.addEventListener('click', this._handleArrowLeftClick.bind(this));
		arrowRight.addEventListener('click', this._handleArrowRightClick.bind(this));
	}

	// возвращает случайное число
	_getRandomNumber() {
		const num = this._array.shift();

		this._array.push(num);

		return num;
	}

	// отключить кнопку "Узнать"
	_disableButtonOpen() {
		this._elements.buttonOpen.setAttribute('disabled', true);
	}

	// отключить кнопку "Чем заняться"
	_disableButtonRandom() {
		this._elements.buttonRandom.setAttribute('disabled', true);
	}

	// отключить кнопки-стрелочки
	_disableArrows() {
		this._elements.arrowLeft.setAttribute('disabled', true);
		this._elements.arrowRight.setAttribute('disabled', true);
	}

	// включить кнопку "Чем заняться"
	_enableButtonRandom() {
		this._elements.buttonRandom.removeAttribute('disabled');
	}

	// включить кнопки-стрелочки
	_enableArrows() {
		this._elements.arrowLeft.removeAttribute('disabled');
		this._elements.arrowRight.removeAttribute('disabled');
	}

	// активировать анимацию загрузчика
	_activateLoader() {
		this._elements.loader.classList.add('flip-card__loader--active');
	}

	// деактивировать анимацию загрузчика
	_deactivateLoader() {
		this._elements.loader.classList.remove('flip-card__loader--active');
	}

	// обновить карточку
	_updateCard(cardId, isFlippedForward = true) {
		const {
			front,
			back,
		} = this._elements;

		const card = document.querySelector(`.card[data-id="${cardId}"]`);
		const clone = $(card).clone(true, true);

		$(back).append(clone);

		const rcl = this._root.classList;

		rcl.add('flip-card--animated');

		if (isFlippedForward) {
			rcl.add('flip-card--flipped-forward');
		} else {
			rcl.add('flip-card--flipped-backward');
		}

		setTimeout(() => {
			rcl.remove('flip-card--animated');

			if (isFlippedForward) {
				rcl.remove('flip-card--flipped-forward');
			} else {
				rcl.remove('flip-card--flipped-backward');
			}

			$(front).empty();
			$(back).empty();
			$(front).append(clone);

			this._currentCardId = cardId;

			helpers.$document.trigger('analytics-card-show', [card.querySelector('.card__text').textContent]);
		}, 1000);
	}

	// ------------------------------------
	// ---------- EVENT HANDLERS ----------
	// ------------------------------------

	_handleButtonOpenClick() {
		const {
			buttonRandomWrapper,
			arrowLeft,
			arrowRight,
		} = this._elements;

		this._disableButtonOpen();
		this._activateLoader();

		setTimeout(() => {
			this._deactivateLoader();
			this._updateCard(this._getRandomNumber());
		}, 1100);

		setTimeout(() => {
			buttonRandomWrapper.classList.remove('is-hidden');
			arrowLeft.classList.remove('is-hidden');
			arrowRight.classList.remove('is-hidden');

			document.querySelector('.main__picture').classList.remove('main__picture--margin');
		}, 1800);

		setTimeout(() => {
			buttonRandomWrapper.classList.remove('flip-card__button-random--hidden');
			arrowLeft.classList.remove('flip-card__arrow--hidden');
			arrowRight.classList.remove('flip-card__arrow--hidden');
		}, 1825);
	}

	_handleButtonRandomClick() {
		this._disableButtonRandom();
		this._disableArrows();
		this._updateCard(this._getRandomNumber());

		setTimeout(() => {
			this._enableButtonRandom();
			this._enableArrows();
		}, 1000);
	}

	_handleArrowLeftClick() {
		this._disableButtonRandom();
		this._disableArrows();

		let num = this._currentCardId - 1;

		if (num === 0) {
			num = 42;
		}

		this._updateCard(num, false);

		setTimeout(() => {
			this._enableButtonRandom();
			this._enableArrows();
		}, 1000);
	}

	_handleArrowRightClick() {
		this._disableButtonRandom();
		this._disableArrows();

		let num = this._currentCardId + 1;

		if (num === 43) {
			num = 1;
		}

		this._updateCard(num);

		setTimeout(() => {
			this._enableButtonRandom();
			this._enableArrows();
		}, 1000);
	}
}

window.addEventListener('load', () => {
	// eslint-disable-next-line no-new
	new FlipCard(document.querySelector('.flip-card'));
});
